import {
  Divider,
  NavLink as MantineNavLink,
  Text,
} from '@mantine/core'
import { NavLink } from 'react-router-dom'

import type { IMenuItems } from '@components/nav/SideBar/Sidebar'
import styles from '../SideBar.module.scss'

export interface ISideBarMenuBlockProps {
  heading: string
  menuItems: IMenuItems[]
  onNavigate: () => void
}

function SideBarMenuBlock({ heading, menuItems, onNavigate }: ISideBarMenuBlockProps) {
  return (
    <>
      <Divider my={'xs'} className={styles.divider} />
      <Text
        size={'xs'}
        tt={'uppercase'}
        fw={700}
        px={'md'}
        py={4}
        className={styles.heading}
      >
        {heading}
      </Text>
      {menuItems.map((menuItem) => (
        <MantineNavLink
          key={menuItem.tab ? `${menuItem.href}/${menuItem.tab}` : menuItem.href}
          component={NavLink}
          to={menuItem.href}
          onClick={onNavigate}
          label={menuItem.title}
          leftSection={menuItem.icon}
          className={styles.navLink}
        />
      ))}
    </>
  )
}

export default SideBarMenuBlock
